import { mdiLoading } from '@mdi/js';
import Icon from '@mdi/react';
import iziToast from 'izitoast';
import { PenIcon } from 'lucide-react';
import { useContext, useMemo, useRef, useState } from 'react';
import { AppAgentContext } from 'src/context/ContextProvider';
import { upsertAgentService } from 'src/services/AgentService';
import { uploadFileCompressedService } from 'src/services/AssetService';
import { appActions } from 'src/store';
import { AiAgent } from 'src/types/AiAgent';
import { ModalType } from 'src/types/Modal';
import { TagsComponent } from '../../shared/TagsComponent';
import { AiAgentActions, AiAgentContext } from './AgentDetailPageComponent';
import { chatbot } from '../ai-agent-v2/AgentLayoutComponentV2';

// const alignOptions = [{ value: 'bottomRight', label: 'bottomRight' },
//     { value: 'bottomLeft', label: 'bottomLeft' },
// ];


export const AgentDesignComponent = () => {
    const { state: { ai_agent }, dispatch } = useContext(AiAgentContext);
    const {
        state: { session: { ai_agent_config: { folder_key_avatars = '', path_avatars = '' } } },
        dispatch: dispatchApp,
    } = useContext(AppAgentContext);
    const [isLoading, setIsLoading] = useState(false);
    const inputAvatarRef = useRef<HTMLInputElement>(null);

    // const selectAvatar = () => {
    //     if (inputAvatarRef.current) {
    //         inputAvatarRef.current.click();
    //     }
    // };

    // const assetsAvatars = useMemoAsync(async () => {
    //     const res = await getFolderFilesService(folder_key_avatars);
    //     if (res.success) {
    //         return res.items;
    //     }
    //     return [];
    // }, [], []);

    const srcImage = useMemo(() => {
        if (ai_agent.avatar) {
            return ai_agent.avatar;
        } else return chatbot;
    }, [ai_agent]);

    const onChangeAvatar = async (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files?.length) {
            const files = [e.target.files[0]];
            setIsLoading(true);
            const res = await uploadFileCompressedService(folder_key_avatars, files);

            if (res.success) {
                const name = res.items[0].name;
                const agent = new AiAgent(ai_agent);
                agent.setAvatar(`${path_avatars + '/' + name}`);
                const resp = await upsertAgentService(agent);
                if (resp.success) {
                    iziToast.success({
                        message: 'Avatar Añadido',
                        position: 'topCenter',
                    });
                    setIsLoading(false);
                    setTimeout(() => {
                        dispatch(AiAgentActions.setAiAgent(agent));
                    }, 1500);
                }
            } else {
                iziToast.warning({
                    message: 'Hubo un problema al subir el archivo',
                    position: 'topCenter',
                });
                setIsLoading(false);
            }
        }
    };

    const openAssetsModal = () => {
        dispatchApp(appActions.openModal({
            type: ModalType.ASSETS_AGENT,
            data: {
                title: 'Seleccionar Imagen',
                data: ai_agent,
                setData: (item) => dispatch(AiAgentActions.setAiAgent(item)),
                onClose: () => dispatchApp(appActions.closeModal(ModalType.ASSETS_AGENT)),
            },
        }));
    };

    return (
        <div className="p-5 flex gap-5">
            <div className="w-full">
                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Mensajes Iniciales</label>
                    <TagsComponent
                        value={ai_agent.getGreetingMessage()}
                        onChange={(value) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setGreetingMessage(value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                    />
                </div>

                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Mensajes de Sugerencia</label>
                    <TagsComponent
                        value={ai_agent.getSuggestedMessage()}
                        onChange={(value) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setSuggestedMessage(value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                    />
                </div>

                <div className="flex gap-2 items-center mb-5">
                    <label htmlFor="">Avatar del Agente</label>
                    <div className="py-2 px-4 flex gap-2">
                        <input
                            className="hidden"
                            type="file"
                            accept="image/png, image/jpeg"
                            onChange={onChangeAvatar}
                            ref={inputAvatarRef}
                        />
                        <div className="relative">
                            <img src={srcImage} alt="avatar" width={60} className="rounded-full" />
                            <div
                                className="bg-white rounded-full cursor-pointer bottom-[-6px] right-0 w-6 flex justify-center items-center shadow absolute"
                                onClick={openAssetsModal}
                            >
                                <PenIcon width={12} />
                            </div>
                        </div>
                        {isLoading && <Icon className="mr-1" size={1} path={mdiLoading} spin />}
                    </div>
                </div>

                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Nombre del Agente</label>
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={ai_agent.agent_name}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none"
                        placeholder="Escribe el nombre del agente"
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                            }
                        }}
                        onChange={(event) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setAgentName(event.target.value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                    />
                </div>

                <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Titulo</label>
                    <input
                        type="text"
                        autoComplete={'off'}
                        value={ai_agent.title}
                        className="py-2 px-4 w-full rounded border border-gray-400 outline-none"
                        placeholder="Escribe el titulo"
                        onKeyDown={(event) => {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                            }
                        }}
                        onChange={(event) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setTitle(event.target.value);
                            dispatch(AiAgentActions.setAiAgent(agent));
                        }}
                    />
                </div>

                <p className="mb-5">Colores</p>
                <div className="flex gap-10">
                    <div>
                        <div className="flex gap-2 items-center mb-5">
                            <div>
                                <input
                                    type="color"
                                    autoComplete={'off'}
                                    value={ai_agent.background_user_color}
                                    className="w-[30px] h-[30px] rounded border border-gray-400 outline-none"
                                    onChange={(event) => {
                                        const agent = new AiAgent(ai_agent);
                                        agent.setBackgroundUserColor(event.target.value);
                                        dispatch(AiAgentActions.setAiAgent(agent));
                                    }}
                                />
                            </div>
                            <label htmlFor="">Color de fondo del usuario</label>
                        </div>
                        <div className="flex gap-2 items-center mb-5">
                            <div>
                                <input
                                    type="color"
                                    autoComplete={'off'}
                                    value={ai_agent.background_agent_color}
                                    className="w-[30px] h-[30px] rounded border border-gray-400 outline-none"
                                    onChange={(event) => {
                                        const agent = new AiAgent(ai_agent);
                                        agent.setBackgroundAgentColor(event.target.value);
                                        dispatch(AiAgentActions.setAiAgent(agent));
                                    }}
                                />
                            </div>
                            <label htmlFor="">Color de fondo del agente</label>
                        </div>
                        <div className="flex gap-2 items-center">
                            <div>
                                <input
                                    type="color"
                                    autoComplete={'off'}
                                    value={ai_agent.button_color}
                                    className="w-[30px] h-[30px] rounded border border-gray-400 outline-none"
                                    onChange={(event) => {
                                        const agent = new AiAgent(ai_agent);
                                        agent.setButtonColor(event.target.value);
                                        dispatch(AiAgentActions.setAiAgent(agent));
                                    }}
                                />
                            </div>
                            <label htmlFor="">Color del icono Enviar</label>
                        </div>
                    </div>
                    <div>
                        <div className="flex gap-2 items-center mb-5">
                            <div>
                                <input
                                    type="color"
                                    autoComplete={'off'}
                                    value={ai_agent.text_user_color}
                                    className="w-[30px] h-[30px] rounded border border-gray-400 outline-none"
                                    onChange={(event) => {
                                        const agent = new AiAgent(ai_agent);
                                        agent.setTextUserColor(event.target.value);
                                        dispatch(AiAgentActions.setAiAgent(agent));
                                    }}
                                />
                            </div>
                            <label htmlFor="">Color de mensaje del usuario</label>
                        </div>
                        <div className="flex gap-2 items-center mb-5">
                            <div>
                                <input
                                    type="color"
                                    autoComplete={'off'}
                                    value={ai_agent.text_agent_color}
                                    className="w-[30px] h-[30px] rounded border border-gray-400 outline-none"
                                    onChange={(event) => {
                                        const agent = new AiAgent(ai_agent);
                                        agent.setTextAgentColor(event.target.value);
                                        dispatch(AiAgentActions.setAiAgent(agent));
                                    }}
                                />
                            </div>
                            <label htmlFor="">Color de mensaje del agente</label>
                        </div>
                    </div>
                </div>

                {/* <div className="grid gap-1 items-center mb-5">
                    <label htmlFor="">Alineación del avatar</label>
                    <Select
                        defaultValue={ai_agent.getSelectCircularAlignment()}
                        value={ai_agent.getSelectCircularAlignment()}
                        options={alignOptions}
                        onChange={(option) => {
                            const agent = new AiAgent(ai_agent);
                            agent.setSelectCircularAlignment(option);
                            dispatch(AiAgentActions.setAiAgent(agent));
                          }}
                    />
                </div> */}
            </div>
        </div>
    );
};
